import React from 'react'
import Footer from '../Footer'
import EducationCLRHS3 from '../EducationCLRHS3'

function CLRHS3() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS3/>
            <Footer/>
        </div>
    )
}

export default CLRHS3
